import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type CalligrapherIconProps = CreateIconComponentProps;
export const CalligrapherIcon: React.FC<CalligrapherIconProps> = ({
  title = 'Calligrapher',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 21s.707-1.084.707-3.293a4 4 0 0 1 4-4c2.21 0 2.586.377 2.586 2.586a4 4 0 0 1-4 4C4.083 20.293 3 21 3 21Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 3A16 16 0 0 0 8.2 13.2M21 3a16 16 0 0 1-10.2 12.8"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10.6 9a9 9 0 0 1 4.4 4.4M9.172 14.828 7.05 16.95"
    />
  </CreateIconComponent>
);
